import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContentLayout } from 'website/components/Layout/components/ContentLayout';

export const TermsAndConditions = () => {
  const { t } = useTranslation();
  return (
    <ContentLayout>
      <Box sx={{
          pt:5.625,
          pb: 3,
          "& .MuiTypography-body2": {
            color: "text.primary",
            fontSize: '0.75rem',
            fontWeight: 500,
          },
          mx: {xs: 3, md: 0},
        }}>
        <Typography variant="h5" color={"primary.light"} fontWeight={600} lineHeight={"normal"} mb={3}>
          {t('website:terms.version')}
        </Typography>
        <Typography variant="h1" mb={4}>
          {t('website:terms.heading')}
        </Typography>
        <Stack flex={1} direction={{xs: "column", md: "row"}} width="100%" height="100%" gap={2}>
          <Stack flex={1} direction="column" gap={4}>
            <Stack direction="column" gap={2}>
              <Typography>
                {t('website:terms.sections.general.title')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.general.items.item1')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.general.items.item2')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.general.items.item3')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.general.items.item4')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.general.items.item5')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.general.items.item6')}
              </Typography>
            </Stack>
            <Stack direction="column" gap={2}>
              <Typography>
                {t('website:terms.sections.userManagement.title')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.userManagement.items.item1')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.userManagement.items.item2')}
              </Typography>
            </Stack>
            <Stack direction="column" gap={2}>
              <Typography>
                {t('website:terms.sections.paidSubscriptions.title')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item1')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item2')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item3')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item4')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item5')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item6')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item7')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item8')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item9')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item10')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item11')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item12')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item13')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item14')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.paidSubscriptions.items.item15')}
              </Typography>
            </Stack>
          </Stack>
          <Stack flex={1} direction="column" gap={4}>
            <Stack direction="column" gap={2}>
              <Typography>
                {t('website:terms.sections.serviceLimitations.title')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.serviceLimitations.items.item1')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.serviceLimitations.items.item2')}
              </Typography>
            </Stack>
            <Stack direction="column" gap={2}>
              <Typography>
                {t('website:terms.sections.data.title')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.data.items.item1')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.data.items.item2')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.data.items.item3')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.data.items.item4')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.data.items.item5Prefix')} <a href="mailto:hello@delegon.com" style={{ textDecoration: "none" }}>
                hello@delegon.com</a>.
              </Typography>
            </Stack>
            <Stack direction="column" gap={2}>
              <Typography>
                {t('website:terms.sections.fairUsePolicy.title')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item1')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item2')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item3')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item4')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item5')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item6')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item7')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item8')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item9')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.fairUsePolicy.items.item10')}
              </Typography>
            </Stack>
            <Stack direction="column" gap={2}>
              <Typography>
                {t('website:terms.sections.damages.title')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.damages.items.item1')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.damages.items.item2')}
              </Typography>
            </Stack>
            <Stack direction="column" gap={2}>
              <Typography>
                {t('website:terms.sections.intellectualProperty.title')}
              </Typography>
              <Typography variant='body2'>
                {t('website:terms.sections.intellectualProperty.items.item1')}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </ContentLayout>
  );
};
